import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  del,
  formDataPatch,
  formDataPost,
  get,
  patch,
  post,
} from "helpers/api_helper";
import {
  ADD_COUPON,
  CASHBACK_UPDATE,
  CLONE_COUPON,
  DELETE_COUPON_STATUS,
  GET_ALL_COUPONS,
  GET_CASHBACK_LIST,
  GET_COUPON_DETAILS,
  GET_REWARD_LIST,
  GET_REWARD_SETTING_LIST,
  UPDATE_COUPON,
  UPDATE_COUPON_STATUS,
  UPDATE_REFERRAL_CODE,
  UPDATE_REWARD_SCREEN,
} from "helpers/url_helper";

export const getAllCoupons = createAsyncThunk(
  GET_ALL_COUPONS,
  async (payload) => {
    const response = await post(GET_ALL_COUPONS, payload);
    return response;
  }
);

export const addCoupon = createAsyncThunk(ADD_COUPON, async (payload) => {
  const response = await formDataPost(ADD_COUPON, payload);
  return response;
});

export const updateCoupon = createAsyncThunk(UPDATE_COUPON, async (payload) => {
  const response = await formDataPatch(UPDATE_COUPON, payload);
  return response;
});

export const getCouponDetails = createAsyncThunk(
  GET_COUPON_DETAILS,
  async (payload) => {
    const response = await post(GET_COUPON_DETAILS, payload);
    return response;
  }
);

export const deleteCoupon = createAsyncThunk(
  DELETE_COUPON_STATUS,
  async (payload) => {
    const response = await del(DELETE_COUPON_STATUS, payload);
    return response;
  }
);

export const updateCouponStatus = createAsyncThunk(
  UPDATE_COUPON_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_COUPON_STATUS, payload);
    return response;
  }
);

export const cloneCoupon = createAsyncThunk(CLONE_COUPON, async (payload) => {
  const response = await post(CLONE_COUPON, payload);
  return response;
});

export const getRewardsList = createAsyncThunk(
  GET_REWARD_LIST,
  async (payload) => {
    const response = await get(GET_REWARD_LIST, payload);
    return response;
  }
);

export const updateRewardsScreen = createAsyncThunk(
  UPDATE_REWARD_SCREEN,
  async (payload) => {
    const response = await formDataPatch(UPDATE_REWARD_SCREEN, payload);
    return response;
  }
);

export const updatecashback = createAsyncThunk(
  CASHBACK_UPDATE,
  async (payload) => {
    const response = await patch(CASHBACK_UPDATE, payload);
    return response;
  }
);

export const getcashbacklist = createAsyncThunk(
  GET_CASHBACK_LIST,
  async (payload) => {
    const response = await get(GET_CASHBACK_LIST, payload);
    return response;
  }
);

export const updatererralcode = createAsyncThunk(
  UPDATE_REFERRAL_CODE,
  async (payload) => {
    const response = await patch(UPDATE_REFERRAL_CODE, payload);
    return response;
  }
);

export const getRewardSettingList = createAsyncThunk(
  GET_REWARD_SETTING_LIST,
  async () => {
    const response = await get(GET_REWARD_SETTING_LIST);
    return response;
  }
);
